import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          读者心声
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-lg p-5 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width="40"
                  height="40"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {comment.comment}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </span>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}